import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

export interface IInputGroup {
  code: number;
  guid: string;
  icon: string;
  image: string;
  title: string;
  title_description: string | null;
}
export interface IGetStoreInputGroupsParams {
  storeGuid?: string;
  only_lendtech?: boolean;
  status?: 'published' | 'pending' | 'rejected' | 'expired';
}

const getStoreInputGroups = async (params: IGetStoreInputGroupsParams) => {
  const {storeGuid, ...rest} = params || {};

  const {data}: {data: IInputGroup[]} = await request.get(
    `/api/v2/store/list-store-input-group/${storeGuid}`,
    {params: cleanFields(rest)},
  );
  return data;
};

export default getStoreInputGroups;
